// extracted by mini-css-extract-plugin
export default {"container":"El-z","disabled":"Fl-z","subtotal":"Gl-z","legal":"Hl-z"};